import { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NewsResearchPage from "@/pages/news-research/page";
import NewsResearchDetailPage from "@/pages/news-research/detail/page";
import AddContentPage from "@/pages/news-research/add-content/page";
import MyLeadsPage from "@/pages/my-leads/page";
import ProductsPage_new from "@/pages/products_new/page";
import CartPage from "@/pages/cart/page";

import TermsPage from "@/pages/Terms/Page";
import ProfilePage from "@/pages/profile/page";
import MyAddressesPage from "@/pages/my-addresses/page";
import MyOrdersPage from "@/pages/my-orders/page";
import CheckoutPage from "@/pages/checkout/page";
import PaymentConfirmationPage from "@/pages/payment-confirmation/page";
import OrderDetailPage from "@/pages/order-detail/page";
import CategoryPage from "@/pages/news-research/add-content/Category";

const HomePage = lazy(() => import("../pages/home/page"));
const SoftwarePage = lazy(() => import("../pages/software/page"));
const ProductsPage = lazy(() => import("../pages/products/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const SignUpPage = lazy(() => import("../pages/signup/page"));
const PrivacyPage = lazy(() => import("../pages/privacy/Page"));
const TermsPage = lazy(() => import("../pages/Terms/Page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/software",
    element: <SoftwarePage />,
  },
  {
    path: "/products",
    element: <ProductsPage_new />,
  },
  // {
  //   path: '/productss',
  //   element: <ProductsPage />,
  // },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/signup",
    element: <SignUpPage />,
  },
  {
    path: "/news-research",
    element: <NewsResearchPage />,
  },
  {
    path: "/news-research-details/:id",
    element: <NewsResearchDetailPage />,
  },
  {
    path: "/news-research/add-content",
    element: <AddContentPage />,
  },
  {
    path: "/my-leads",
    element: <MyLeadsPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/address",
    element: <MyAddressesPage />,
  },
  {
    path: "/orders",
    element: <MyOrdersPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/payment-confirmation/:txnid",
    element: <PaymentConfirmationPage />,
  },
  {
    path: "/order/:orderId",
    element: <OrderDetailPage />,
  },
   {
    path: "/category",
    element: <CategoryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
